import Icon from '../../../components/AppIcon';

const SkillsSection = ({ skills }) => {
  if (!skills || skills?.length === 0) {
    return (
      <div className="bg-card rounded-lg shadow-sm border border-border p-6">
        <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Wrench" className="w-5 h-5 text-primary" />
          Skills & Expertise
        </h2>
        <p className="text-muted-foreground text-center py-8">No skills listed</p>
      </div>
    );
  }

  // Categorize skills (simple categorization based on common patterns)
  const categorizeSkills = (skillsList) => {
    const categories = {
      technical: [],
      creative: [],
      service: [],
      other: []
    };

    const technicalKeywords = ['programming', 'web', 'app', 'software', 'database', 'network', 'it', 'tech'];
    const creativeKeywords = ['design', 'graphic', 'video', 'photo', 'art', 'creative', 'content'];
    const serviceKeywords = ['cleaning', 'repair', 'maintenance', 'plumbing', 'electrical', 'carpentry', 'construction'];

    skillsList?.forEach(skill => {
      const lowerSkill = skill?.toLowerCase();
      if (technicalKeywords?.some(keyword => lowerSkill?.includes(keyword))) {
        categories?.technical?.push(skill);
      } else if (creativeKeywords?.some(keyword => lowerSkill?.includes(keyword))) {
        categories?.creative?.push(skill);
      } else if (serviceKeywords?.some(keyword => lowerSkill?.includes(keyword))) {
        categories?.service?.push(skill);
      } else {
        categories?.other?.push(skill);
      }
    });

    return categories;
  };

  const categorizedSkills = categorizeSkills(skills);

  const categoryConfig = [
    { key: 'technical', label: 'Technical Skills', icon: 'Code', color: 'text-blue-600 bg-blue-50' },
    { key: 'creative', label: 'Creative Skills', icon: 'Palette', color: 'text-[#FF6A00] bg-orange-50' },
    { key: 'service', label: 'Service Skills', icon: 'Hammer', color: 'text-[#FF6A00] bg-orange-50' },
    { key: 'other', label: 'Other Skills', icon: 'Star', color: 'text-[#FF6A00] bg-orange-50' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6 flex items-center gap-2">
        <Icon name="Wrench" className="w-5 h-5 text-primary" />
        Skills & Expertise
      </h2>

      <div className="space-y-6">
        {categoryConfig?.map(category => {
          const categorySkills = categorizedSkills?.[category?.key];
          if (!categorySkills || categorySkills?.length === 0) return null;

          return (
            <div key={category?.key}>
              <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-3 flex items-center gap-2">
                <Icon name={category?.icon} className="w-4 h-4" />
                {category?.label}
              </h3>
              <div className="flex flex-wrap gap-2">
                {categorySkills?.map((skill, index) => (
                  <span 
                    key={index}
                    className={`px-4 py-2 rounded-full text-sm font-medium ${category?.color} transition-transform hover:scale-105`}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SkillsSection;